import React from 'react';
import DataFeedActions from '../actions/DataFeedActions';
import DataFeedStore from '../stores/DataFeedStore';
import PileCheckDataTable from './PileCheckDataTable.react';
import RaisedButton from 'material-ui/RaisedButton';

function getCurrentState() {
    return {
        checked: DataFeedStore.getPileSelection(),
        processedCount: DataFeedStore.getProcessedInSession(),
        noMoreToProcess: DataFeedStore.getNoMoreToProcess(),
        unapproved: DataFeedStore.getUnapprovedPile()
    }
}

class PileCheck extends React.Component {

    constructor(props) {
        super(props);

        this._onChange = this._onChange.bind(this)

        this.state = getCurrentState(props);
    }

    componentWillReceiveProps(props) {
        this.setState(getCurrentState(props));
    }
    componentDidMount() {
        DataFeedStore.addChangeListener(this._onChange);

        DataFeedActions.loadNonApprovedForPile();
    }
    componentWillUnmount() {
        DataFeedStore.removeChangeListener(this._onChange);
    }
    render() {

        let display;

        if (this.state.noMoreToProcess) {
            display = (
                <p>All records processed, please refresh later to find more</p>
            )
        } else {
            display = (
                <PileCheckDataTable checked={this.state.checked} data={this.state.unapproved}/>
            )
        }

        return (

            <div className="DataFeed">

                <div className="row">
                    <div className="col-md-3">
                        <h2>Pile Check</h2>
                    </div>

                    <div className="col-md-2">

                        <select style={{marginTop: 30}} onChange={(event) => this._setType(event.target.value)}>
                            <option value="all">All</option>
                            <option value="machine">Connected to Machine Rules</option>
                            <option value="telco">Smells like Telco</option>
                            <option value="neustar">Neustar ISP</option>
                        </select>
                    </div>
                    <div className="col-md-2 col-md-offset-1">

                        <p style={{marginTop: 30}}>Processed {this.state.processedCount}</p>
                    </div>
                    <div className="pull-right">

                        <RaisedButton
                            style={{marginTop: 15}}
                            label="Remove"
                            secondary={true}
                            onTouchTap={() => this._processUnapproved()}
                        />

                    </div>
                </div>

                <div className="clr"></div>
                <br/>

                {display}
            </div>
        )
    }

    _setType(type) {

        DataFeedActions.setPileCheckToLoadType(type);
    }

    _processUnapproved() {

        DataFeedActions.processUnapproved();
    }

    _onChange() {

        this.setState(getCurrentState());
    }
}

export default PileCheck;



// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/components/PileCheck.react.js